export const scrollToComponent = (
  ref: React.RefObject<HTMLInputElement>,
  yOffset = -16
): void => {
  const top = ref.current?.getBoundingClientRect().top || 0
  window.scrollTo({
    top: top + window.pageYOffset + yOffset,
    behavior: 'smooth'
  })
}

export interface BlackboxInfo {
  blackbox: string
  finished: boolean
}

export interface IOvation extends Window {
  IGLOO: {
    getBlackbox: () => BlackboxInfo
  }
}

/**
 * Iovation Blackbox: encoded device fingerprint string
 * used to identify and prevent potential fraud
 */
export const readBlackBox = () => {
  const { IGLOO } = window as unknown as IOvation
  const blackBox = IGLOO.getBlackbox ? IGLOO.getBlackbox().blackbox : ''
  return { blackBox }
}
